import { Injectable } from '@angular/core';
import {httpResource} from '@angular/common/http';
import {Page} from './pages.interface';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PageService {

  constructor() { }
  pageContentResource = httpResource<Page>(() => `${environment.apiUrl}/pages/contact-us`);
  homePageContentResource = httpResource<Page>(() => `${environment.apiUrl}/pages/home-page`);
}
